import { render } from "./SpecHospital.vue?vue&type=template&id=6d745f0e"
import script from "./SpecHospital.vue?vue&type=script&lang=js"
export * from "./SpecHospital.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__